import styled, { css } from 'styled-components'

export const Controls = styled.div`
    position: absolute;
    background: #f2f2f2;
    z-index: 32;
    border-radius: 0 0 12px 12px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    ${props =>
        props.isWhiteboardMode
            ? css`
                  height: 3.5vw;
                  width: 78vw;
                  bottom: 0;
                  left: 0;
              `
            : css`
                  height: 3.5vw;
                  width: 60vw;
                  bottom: 0;
                  left: 0;
              `}
    @media only screen and (min-width: 1024px) and (max-width: 1366px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {
        ${props =>
            props.isWhiteboardMode
                ? css`
                      width: 78vw;
                  `
                : css`
                      width: 66vw;
                  `}
    }
    @media only screen and (max-width: 992px) {
        z-index: 0;
        ${props =>
            !props.isWhiteboardMode
                ? css`
                      width: 70vw;
                  `
                : css`
                      width: 98vw;
                  `}
    }
`

export const Navigation = styled.div`
    width: 132px;
    height: 36px;
    border: 1px solid #e0e0e0;
    box-sizing: border-box;
    border-radius: 18px;
    height: 36px;
    background: #ffffff;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-right: 10px;

    @media only screen and (max-width: 992px) {
        width: 10vw;
        height: 3vw;
    }
`

export const AddPages = styled.div`
    background: #ffffff;
    cursor: pointer;
    width: 35px;
    height: 36px;
    border: 1px solid #e0e0e0;
    box-sizing: border-box;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    opacity: ${props => (props.disableAddPage ? '0.5' : null)};
`
export const Icon = styled.img`
    cursor: pointer;
`
export const LeftIcon = styled.img`
    cursor: pointer;
    pointer-events: ${props => (props.disableLeftNavigation ? 'none' : null)};
    opacity: ${props => (props.disableLeftNavigation ? '0.5' : null)};
`
export const RightIcon = styled.img`
    cursor: pointer;
    pointer-events: ${props => (props.disableRightNavigation ? 'none' : null)};
    opacity: ${props => (props.disableRightNavigation ? '0.5' : null)};
`

export const PageNumber = styled.div`
    margin: 0 1vw 0 1vw;
`
